import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';

import { combineLatest, Observable, Subject } from 'rxjs';
import { map, shareReplay, takeUntil } from 'rxjs/operators';

import { ApiFragment } from '../../../entities/api-fragment.entity';
import { BaseColumnComponent } from '../../../services/base-column-component';

@Component({
    standalone: false,
    selector: 'digihaven-checkmark-cell',
    templateUrl: './checkmark-cell.component.html'
})
export class CheckmarkCellComponent extends BaseColumnComponent<ApiFragment> implements OnDestroy {
    private readonly destroy$: Subject<void> = new Subject();

    value$: Observable<boolean>;

    constructor(cd: ChangeDetectorRef) {
        super(cd);

        this.value$ = combineLatest([this.data$, this.fieldDefinition$]).pipe(
            map(([record, fieldDefinition]): boolean => record.getField(fieldDefinition.DottedKey)),
            takeUntil(this.destroy$),
            shareReplay()
        );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
